import styled from "styled-components";
import CustomModal from "../../../components/common/CustomModal";

type Props = {
  currency?: string;
  isMobile?: boolean;
};

export const CarouselWrapper = styled.div`
  position: relative;
  margin: 20px 0;

  &:hover [data-carousel-arrow] {
    opacity: 1;
  }
`;

export const WalletSummarySection = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CarouselArrow = styled.button<{ $direction: "left" | "right" }>`
  position: absolute;
  top: 50%;
  ${(props) => (props.$direction === "left" ? "left: 8px;" : "right: 8px;")}
  transform: translateY(-50%);
  z-index: 2;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 12px;
  background: #FF4A01;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease, background 0.2s ease;
  box-shadow: 0px 20px 56px 0px #0000004A;

  &:hover {
    background: var(--primary-brand-hover);
  }

  &:focus-visible {
    opacity: 1;
  }

  svg {
    transform: ${(props) => (props.$direction === "right" ? "rotate(180deg)" : "none")};
  }

  svg path {
    stroke: #ffffff;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const WalletSummaryCard = styled.button<Props>`
  background-color: #FCFCFC;
  cursor: ${(props) => (props.currency === "GBP" ? "not-allowed" : "pointer")};
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  flex: 0 0 214px;
  height: 128px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  color: #000000;
  text-align: left;
  transition: border-color 0.2s ease;

  h4 {
    font-family: "Suisse International", sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.4px;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  &:hover {
    color: #000000;
    border-color: #d9d9d9;
  }
`;

export const WalletCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const WalletCardLabel = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Inter";

  strong {
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
  }

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #757575;
  }
`;

export const WalletSummaryCardIcon = styled.span`
  border-radius: 50%;
  background: #e8eaee;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;

  button {
    padding: 0 16px;
  }
`;

export const AllWalletsModalWrapper = styled(CustomModal)`
  && .ant-modal-close {
    top: 24px;
    right: 24px;
  }

  && .ant-modal-close-x {
    width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 100%;
    background: #F5F5F5;
  }
`;

export const AllWalletsTitle = styled.h3`
  font-family: "Suisse International", sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.4px;
  color: #000000;
  margin: 0 0 16px;
`;

export const AllWalletsList = styled.div`
  margin-top: 16px;
  max-height: 340px;
  overflow-y: auto;
`;

export const AllWalletsSectionLabel = styled.p`
  font-family: "Inter";
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #8f8f8f;
  margin: 8px 0 4px;
`;

export const AllWalletsItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  background: transparent;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #fafafa;
  }

  .balance {
    font-family: "Inter";
    font-size: 12px;
    color: #757575;
    white-space: nowrap;
  }

  svg circle {
    fill: var(--primary-brand);
  }
`;

export const AllWalletsEmpty = styled.p`
  font-family: "Inter";
  font-size: 14px;
  color: #757575;
  text-align: center;
  margin: 24px 0;
`;

export const SelectedDropdownOption = styled.div`
  display: flex;
  align-items: center;

  & li {
    margin-right: 10px;
  }
`;

export const ButtonsDiv = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  margin-top: 16px;

  button {
    width: 100%;
  }
`;

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: #000000;
  letter-spacing: -0.48px;
  font-family: "Suisse International", sans-serif;
`;

export const Title = styled.p`
  font-family: "Suisse International", sans-serif;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.4px;
  color: #000000;
  margin-bottom: 20px;
`;

export const TermsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 20px;

  input[type="checkbox"] {
    margin: 0;
    vertical-align: middle;
  }

  p {
    margin-left: 8px;
    margin: 0;
    vertical-align: middle;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    text-align: left;
  }
  span {
    color: var(--primary-brand);
    cursor: pointer;
  }
`;

export const TernsContent = styled.div`
  h1 {
    font-family: "Suisse International", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.02em;
    text-align: center;
  }

  p,
  ul {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #757575;
  }

  h3 {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    font-weight: 700;
    color: #757575;
  }
  span {
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    color: #757575;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;

export const SwapButtonDiv = styled.div<Props>`
  display: ${(props) => (props.isMobile ? "none" : "block")};
  width: ${(props) => (props.isMobile ? "100%" : "143px")};
  margin: ${(props) => (props.isMobile && "0.5rem 0 1.5rem 0")};

  @media (max-width: 768px) {
    display: ${(props) => (props.isMobile ? "flex" : "none")};
  }
`;

export const SwapWrappBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  span {
    font-size: 12px;
    text-align: center;
  }
`;

export const SuccessModalWrapper = styled.div`
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

export const SuccessContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const SuccessHeader = styled.h1`
 font-weight: 500;
 font-size: 20px;
 line-height: 32px;
 letter-spacing: -2%;
 text-align: center;
 font-family: "Suisse International", sans-serif;
 color: #000000;
`

export const SuccessContent = styled.p`
 font-family: Inter;
 font-size: 14px;
 font-weight: 400;
 line-height: 16px;
 text-align: center;
 font-family: "Suisse International", sans-serif;
 color: #666666;
`